import {useUpmPlant} from '@hconnect/upm'
import {Loading} from '@hm/fundamental'

import {useUrlParam} from '../routing/hooks'

import {KilnValidationWrapper} from './components/KilnValidationWrapper'
import {RefraPlanningBody} from './RefraPlanningBody'

import {PageHeaderWithSwitch} from '@refra/modules/common/components'
import {useKilnNodesQuery} from '@refra/modules/common/hooks/queries'
import {
  useRefraModal,
  KilnsProvider,
  RefraSettingsProvider
} from '@refra/modules/common/providers'

export const RefraPlanning: React.FC = () => {
  const {modal} = useRefraModal()

  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId: plantCode})

  const {data: kilnNodes} = useKilnNodesQuery(upmPlant.upmId)

  if (!kilnNodes) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="refra_planning_loader" />
      </div>
    )
  }

  // Safety net for the plants without kilns,
  // even though the product should not be available for such plants
  if (kilnNodes.length === 0) return null

  return (
     <RefraSettingsProvider>
      <KilnsProvider kilnNodes={kilnNodes}>
          <div className="px-6">
            <PageHeaderWithSwitch kilnNodes={kilnNodes} titleKey={'refraPlanning.title'} />
            <KilnValidationWrapper>
              <RefraPlanningBody />
            </KilnValidationWrapper>
            {modal}
          </div>
      </KilnsProvider>
    </RefraSettingsProvider>
  )
}
